import DataDisplayRowI from "../DataDisplayRowI";
import getPCComponentRow from "../DataDisplayRow/PCComponentRow";
import DataDisplayTable from "../DataDisplayTable";

class PCComponentTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getPCComponentRow()
    }
}

let pcComponentTable: PCComponentTable | null = null;

export default function getPCComponentTable(): PCComponentTable {
    if (pcComponentTable === null)
        pcComponentTable = new PCComponentTable()
    return pcComponentTable
}